import { useTranslation } from 'react-i18next';

import cn from 'classnames';

import { isWebinarComplete, isWebinarJoinable } from '~/routes/webinars/_utils/isWebinarJoinable';

interface WebinarReservationInfoProps {
  redirectUrl: string;
  eventStartsAt?: string | null;
  eventEndsAt?: string | null;
  status?: string;
  className?: string;
}

const WebinarReservationInfo = ({
  redirectUrl,
  eventStartsAt,
  eventEndsAt,
  status,
  className,
}: WebinarReservationInfoProps) => {
  const { t } = useTranslation();
  const baseClassName = cn('text-center text-sm w-full', className);

  if (isWebinarComplete({ eventEndsAt, status })) {
    return <p className={baseClassName}>{t('products.webinar.event_complete')}</p>;
  }

  const canJoin = isWebinarJoinable({ eventStartsAt, eventEndsAt, status });

  return (
    <p className={baseClassName}>
      {t('products.webinar.already_registered')}
      {canJoin && (
        <>
          {' '}
          <a href={redirectUrl} className="underline hover:no-underline">
            {t('products.webinar.join_webinar')}
          </a>
        </>
      )}
    </p>
  );
};

export default WebinarReservationInfo;
